/**
 * Country pages model
 * @returns {{country: string}}
 * @constructor
 */
export default function CountryPageEventModel() {
    return {
        country: window.countryCode,
    }
}